export default {"src":"/_next/static/media/infoCircle.bffc80ea.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};